import { render, staticRenderFns } from "./attachment-editor.vue?vue&type=template&id=14a92f66&"
import script from "./attachment-editor.vue?vue&type=script&lang=js&"
export * from "./attachment-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports